
import { Component, Vue } from 'vue-property-decorator'
import UsernameLogin from './username.vue'
@Component({
  name: 'Login',
  components: {
    UsernameLogin
  }
})
export default class extends Vue {
  // 控制台版本号（登录页可见）
  private version = '0.1.2'
  // POS 收款端当前版本
  private posVersion = '2.3.0'
  // 安装包下载地址：走 OSS 自有 CNAME 域名 oss.xjjnxd.com（放行 .apk 且已绑 HTTPS）
  private posclientApkUrl = 'https://oss.xjjnxd.com/posclient/apk/posclient-2.3.0.apk'
  private cardmanagerApkUrl = 'https://minio.xjjnxd.com/cng-client-install/cardmanager.apk'
  private img_gongan = ''
}
